import { useRef, useEffect, useState, createElement } from 'react';

import { Routes, Route, useNavigate, Navigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { getProductFromURL, getPageFromURL } from '../../components/Common/GlobalFunc';
import Header from '../../components/Header/Header';
import LandingPage from '../../components/Home/LangingPage';
import RacingPage from '../../components/Home/RacingPage';
import FootballPage from '../../components/Home/FootballPage';
import MarksixPage from '../../components/Home/MarksixPage';
import Footer from '../../components/Footer/Footer';
import MobileBottomMenu from '../../components/Menu/MobileBottomMenu';
import BetSlip from '../../components/BetSlip/BetSlip';
import { useEarlySettlementTxnQuery } from '../../components/Home/Data/EarlySettlementTxnQueryHook';
import { useWindowSize, useGetMtelConfig } from '../../components/Common/CommonHooks';
import { Scrollbars } from 'react-custom-scrollbars-2';
import { fbMenuData } from '../../components/Home/Data/fbMenu';
import { isLogonHigh } from '../../components/BetSlip/LoginIBHooks';
import useMqttClient from '../../components/Common/hooks/useMqttClient';
import useGetFootballMenuData from '../../components/Football/Data/useGetFootballMenuData';
import { GlobalContext } from '../../contexts/GlobalContext';
import { useLocalStorage } from '../../components/Common/hooks';
import { LogoutReminderPopupType } from '@/src/components/Common/constants';
import AlertPopup from '../../components/Common/AlertPopup/AlertPopup';
const CustomScrollbars = (props) => {
    // const { isMobileSize } = useWindowSize();
    return (
        <Scrollbars
            autoHide
            autoHideTimeout={2000}
            autoHideDuration={200}
            className="StandardPage-scrollbars"
            style={{ height: '100vh' }}
            autoHeight={false}
            // thumbMinSize={600}
            {...props}
            renderView={(props) => {
                return createElement('div', {
                    ...props,
                    'data-testid': 'matchesList_scrollView',
                    id: 'scrollView'
                });
            }}
        />
    );
};

function StandardPage({
    loginLogoutHook,
    loginLogoutFR,
    login_shared_states,
    globalState,
    setGlobalState,
    racingNotesData,
    sessionServerTimeRef
}) {
    const { i18n } = useTranslation();
    const { isMobileSize } = useWindowSize();
    const racingPageFunc = useRef();
    const [fbMenuGqlVars, setFbMenuGqlVars] = useState(fbMenuData);
    const globalRef = useRef({
        isLoadingData: false,
        isSendingBet: false,
        enableESButton: true,
        allupBoxChecked: false
    });
    const mqttClient = useMqttClient({ globalState });
    const esHook = useEarlySettlementTxnQuery({ mqttClient, globalState });
    const [bottomMenuAddSlipButtonDisable, setBottomMenuAddSlipButtonDisable] = useState(false);
    const [clearAllHorseSelectionsButtonDisable, setClearAllHorseSelectionsButtonDisable] = useState(false);
    const [isWaitMobileFootballAllupCal, setIsWaitMobileFootballAllupCal] = useState(false);
    const [isShowMobileFootballAllupCal, setIsShowMobileFootballAllupCal] = useState(false);
    const [cwlPage, setCwlPage] = useState(new URLSearchParams(location.search).get('cwlPage') || '');
    const [isShowPcardPanel, setIsShowPcardPanel] = useState(new URLSearchParams(location.search).get('LPEntry') === '1' || !!cwlPage);
    const [openCWL, setOpenCWL] = useState(null);
    const [jumpFbHomePage, setJumpFbHomePage] = useState(null);
    const [cashoutInProcess, setCashoutInProcess] = useState(false);

    const [rsShowType, setRsShowType] = useLocalStorage('rsShowType', 'Simple');
    const [rsShowPage, setRsShowPage] = useState('RS_KEY_FACTORS'); // num : RS_KEY_FACTORS | RS_VIDEO | RS_RESULT
    const [rsIsWatchVideo, setRsIsWatchVideo] = useLocalStorage('rsIsWatchVideo', true);
    const [rsRaceData, setRsRaceData] = useState();

    const [ViewResultButtomDisabled, setViewResultButtomDisabled] = useState(false);
    const [disableRsMenu, setDisableRsMenu] = useState(false);
    const [rsResultSticky, setRsResultSticky] = useState(false);
    const resetRsImportanceValue = useRef(() => { });
    const setLocalParaRef = useRef(() => { });
    const RacingContextRef = useRef({});
    const mtelConfig = useGetMtelConfig();

    const { loadFootballMenuQuery } = useGetFootballMenuData(setFbMenuGqlVars);

    useEffect(() => {
        loadFootballMenuQuery(60, []);
    }, []);

    const navigate = useNavigate();

    const updateGlobalState = (args) => {
        // SQ0248-2160
        setGlobalState((globalState) => {
            return { ...globalState, ...args };
        });
        globalRef.current = {
            isSendingBet: args.isSendingBet != null ? args.isSendingBet : globalRef.current.isSendingBet,
            enableESButton: args.enableESButton != null ? args.enableESButton : globalRef.current.enableESButton,
            allupBoxChecked: args.allupBoxChecked != null ? args.allupBoxChecked : globalRef.current.allupBoxChecked
        };
    };

    const resetGlobalState = () => {
        setGlobalState({
            product: globalState.product,
            betType: globalState.betType,
            betslipState: globalState.betslipState,
            mtg: globalState.mtg,
            jtcPara: [],
            targetPage: '',
            commonCtrl: globalState.commonCtrl,
            commonCtrlLoading: globalState.commonCtrlLoading,
            cashoutData: globalState.cashoutData
        });
        globalRef.current = {
            isLoadingData: false,
            isSendingBet: false,
            enableESButton: true,
            allupBoxChecked: globalRef.current.allupBoxChecked
        };
    };

    const ToProductHomePage = ({ prod, lang }) => {
        let urlStr = `/${i18n.language}/${prod}/home`;
        if (prod === 'ewin') {
            urlStr = `/${i18n.language}/home`;
            if (lang && ['/en', '/ch'].includes(location.pathname)) {
                urlStr = `${location.pathname}/home`;
            }
        }
        navigate(urlStr);
        return null;
    };

    const { isShowCSLogoutDialog, isShowPassvieLogoutDialog, logoutReminderPopupState } = loginLogoutHook;

    if (window.globalConfig.IS_SPEEDBET && !isLogonHigh()) {
        if (
            (window.globalConfig.NEW_LOGOUT_REMINDER_FLOW &&
                logoutReminderPopupState === LogoutReminderPopupType.closed) ||
            (!window.globalConfig.NEW_LOGOUT_REMINDER_FLOW && !(isShowCSLogoutDialog || isShowPassvieLogoutDialog))
        ) {
            return <Navigate to={`/${i18n.language}/login`} />;
        }
    }
    if (window.globalConfig.IS_EWIN2 && !isLogonHigh()) {
        if (
            (window.globalConfig.NEW_LOGOUT_REMINDER_FLOW &&
                logoutReminderPopupState === LogoutReminderPopupType.closed) ||
            (!window.globalConfig.NEW_LOGOUT_REMINDER_FLOW && !(isShowCSLogoutDialog || isShowPassvieLogoutDialog))
        ) {
            return <Navigate to={`/${i18n.language}/eWin2/login`} />;
        }
    }

    return (
        <CustomScrollbars>
            <div className={`StandardPage ${getProductFromURL()} ${getPageFromURL()}`}>
                <style>{`
                    .GL .icon-racingnote, .pcard .icon-racingnote{
                    background-image: url(${window.sitecoreVars.NOTES_ADD_BLACK_ICON});
                    }
                    .GL .icon-racingnoteUpdate, .pcard .icon-racingnoteUpdate{
                    background-image: url(${window.sitecoreVars.NOTES_UPD_ICON});
                    }
                    .icon-racingnote {
                        background-image: url(${window.sitecoreVars.NOTES_ADD_WHITE_ICON});
                    }
                    .icon-racingnoteUpdate{
                        background-image: url(${window.sitecoreVars.NOTES_UPD_WHITE_ICON});
                    }
                    .rc-note.add {
                        background-image: url(${window.sitecoreVars.NOTES_ADD_ICON});
                    }
                    .rc-note.update {
                        background-image: url(${window.sitecoreVars.NOTES_UPD_ICON});
                    }
                    .rc-note.fav {
                        background-image: url(${window.sitecoreVars.NOTES_FAV_ICON});
                    }
                `}</style>
                <GlobalContext.Provider
                    value={{
                        rsShowType,
                        setRsShowType,
                        rsShowPage,
                        setRsShowPage,
                        rsRaceData,
                        setRsRaceData,
                        setLocalParaRef,
                        RacingContextRef,
                        rsIsWatchVideo,
                        setRsIsWatchVideo,
                        ViewResultButtomDisabled,
                        setViewResultButtomDisabled,
                        disableRsMenu,
                        setDisableRsMenu,
                        rsResultSticky,
                        setRsResultSticky,
                        resetRsImportanceValue,
                        globalState,
                        globalRef,
                        updateGlobalState,
                        resetGlobalState,
                        racingPageFunc,
                        fbMenuGqlVars,
                        loadFootballMenuQuery,
                        racingNotesData,
                        isWaitMobileFootballAllupCal,
                        setIsWaitMobileFootballAllupCal,
                        isShowMobileFootballAllupCal,
                        setIsShowMobileFootballAllupCal,
                        isShowPcardPanel,
                        setIsShowPcardPanel,
                        openCWL,
                        setOpenCWL,
                        cwlPage,
                        setCwlPage,
                        bottomMenuAddSlipButtonDisable,
                        setBottomMenuAddSlipButtonDisable,
                        clearAllHorseSelectionsButtonDisable,
                        setClearAllHorseSelectionsButtonDisable,
                        jumpFbHomePage,
                        setJumpFbHomePage,
                        cashoutInProcess,
                        setCashoutInProcess,
                        mqttClient,
                        loginLogoutHook,
                        sessionServerTimeStamp: sessionServerTimeRef?.current,
                        esHook,
                        mtelConfig
                    }}
                >
                    <Header loginLogoutHook={loginLogoutHook} />
                    <div className="main-content">
                        <div className="left-content">
                            <Routes>
                                <Route path="/racing" element={<ToProductHomePage prod="racing" />} />
                                <Route path="/football" element={<ToProductHomePage prod="football" />} />
                                <Route path="/marksix" element={<ToProductHomePage prod="marksix" />} />
                                <Route
                                    path="/:lang/racing/:page/:date/:venue/:raceNo"
                                    element={<RacingPage ref={racingPageFunc} />}
                                />
                                <Route
                                    path="/:lang/racing/:page/:date/:venue"
                                    element={<RacingPage ref={racingPageFunc} />}
                                />
                                <Route path="/:lang/racing/:page" element={<RacingPage ref={racingPageFunc} />} />
                                <Route path="/:lang/racing" element={<RacingPage ref={racingPageFunc} />} />
                                <Route path="/:lang/football/:page/:matchId" element={<FootballPage />} />
                                <Route path="/:lang/football/:page" element={<FootballPage />} />
                                <Route path="/:lang/football" element={<FootballPage />} />
                                <Route path="/:lang/marksix/:page/:date" element={<MarksixPage />} />
                                <Route path="/:lang/marksix/:page" element={<MarksixPage />} />
                                <Route path="/:lang/marksix" element={<MarksixPage />} />
                                <Route path="/:lang/home" element={<LandingPage />} />
                                <Route path="/:lang" element={<ToProductHomePage prod="ewin" lang="lang" />} />
                                <Route path="*" element={<ToProductHomePage prod="ewin" />} />
                            </Routes>
                        </div>
                        <BetSlip
                            product={globalState.product}
                            useLoginLogout={loginLogoutHook}
                            useLoginLogoutFR={loginLogoutFR}
                            login_shared_states={login_shared_states}
                        />
                    </div>
                    <Footer />
                    {isMobileSize && <MobileBottomMenu />}
                    <AlertPopup

                    />
                </GlobalContext.Provider>
            </div>
        </CustomScrollbars>
    );
}

export default StandardPage;
